<div class="modal-column">
  <div class="log-in-form-block">
    <form (ngSubmit)="captchaRef.execute();loadingLogin = true" [formGroup]="form" autocomplete="off" novalidate>
      <h5>Welcome back to Edgeless</h5>
      <p class="subtext">Win like never before!</p>
      <div class="spacer-10"></div>
      <app-form-input formControlName="username" type="email" title="Email address" data-id="modalLogin-username-input">
      </app-form-input>
      <app-form-input formControlName="password" type="password" title="Password" data-id="modalLogin-password-input">
      </app-form-input>
      <div class="resend-confirmation-code">
        <a [routerLink]="['/', {outlets: { modal: 'forgot-password' } } ]" class="forgot-pass"
           data-id="modalLogin-forgot-href">Forgot password?</a>
      </div>
      <app-form-button type="submit" class="primary full-width" [loading]="loadingLogin" [disabled]="loadingLogin"
                       data-id="modalLogin-login-button">Log In
      </app-form-button>
      <div class="log-in-or-text">Or</div>
      <a [routerLink]="['/', {outlets: { modal: 'signup' } } ]">
        <app-form-button type="button" class="full-width" data-id="modalLogin-signup-button">
          Sign Up
        </app-form-button>
      </a>
      <re-captcha #captchaRef="reCaptcha" (resolved)="$event && login($event)"></re-captcha>
    </form>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="modalLogin-close-href">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/login/login-modal.template.html